/* The SkyeHoverBox Class - (in-progress for class conversion) 
Based on previous factory function. Each Hoverbox must have 
this structure in HTML. 

		<div class="hoverbox">
			<div class="hoverbox-block__action__layer"></div>
				<div>
					<p class="hoverbox-block__content" tabindex="0">Initial content goes here...</p>
				</div>
		</div>

The hoverbox  top level class can be combined with Bootstrap 
block classes such as .col-md-6, .col-md-4, etc.

For example:
<div class="col-md-6 hoverbox">

JS: Insert the content in an object and it will be used based on key indexes that match the array indexes of your hover box set.
		'message1' for each box should match the initial HTML content.
		'message2' will replace message 1 for each box during 'focus' and 'mouseover' events. 
		*Content will revert on 'mouseout' or 'blur' events.
All hover boxes are called from the DOM using querySelectorAll which returns an array. 

This class is activated like this:

	var hoverbox = new SkyeHoverBox(businessBenefits);
	hoverbox.ActivateHoverBoxes();

	Instantiation only uses one argument, which is the content object - example below.

	var businessBenefits =  {
	0: {
		message1: '<span>Increased Employee Satisfaction</span>',
		message2: '<span>68% of workers say training and development is the most important workplace policy. <span class="sup-script">1</span></span>'
	},
	1: {
		message1: '<span>Increased Employee Retention</span>',
		message2: '<span>95% of hiring managers consider employee training as a key retention tool. <span class="sup-script">2</span></span>'
	},
	2: {
		message1: '<span>Increased Employee Engagement and Productivity</span>',
		message2: '<span>Companies with engaged employees outperform those without by over 200%. <span class="sup-script">3</span></span>'
	},
	3: {
		message1: '<span>Increased Company Profitability and Stability</span>',
		message2: '<span>Companies that provide employees with comprehensive training have 218% higher income per employee than those that do not provide training. <span class="sup-script">4</span></span>'
	}
};


*/
	
	/* Skye HoverBox Class */
	class SkyeHoverBox{
	constructor( contentObject ){	
		this.contentObject = contentObject;
		this.intCnt = 0;
		this.objectKeys = Object.keys(this.contentObject);
	}
	
	/* Return the contentObject */
	contentObject(){
		return this.contentObject;
	}
	
	/* Set a new content object for the hover boxes */
	setContentObject(newContentObject){
		this.contentObject = newContentObject;
		return this.contentObject;
	}
	
	/* GET -> Retrieve all hover boxes on the page in an array */
	get skyeHoverBoxes(){
		var hoverBoxes = document.querySelectorAll('.hoverbox');
		return hoverBoxes;
		}
	/* Compose the hover boxes and sort the content for each box based on object indexes to array indexes */
	ActivateHoverBoxes(){
		/* Get the hover boxes in an array */
		var hoverboxes = this.skyeHoverBoxes;
		/* Object composition check */
		if(this.contentObject[this.intCnt].hasOwnProperty('message1') && this.contentObject[this.intCnt].hasOwnProperty('message2') ){
			
			for( this.intCnt = 0; this.intCnt < hoverboxes.length; this.intCnt+=1){
					/* Grab the correct content from the content object object index equals element index */
					var contentMessage1 = this.contentObject[this.intCnt].message1;
					var contentMessage2 = this.contentObject[this.intCnt].message2;
		
					/* Get the current Hover Box container .i.e. element with class .hoverbox*/
					var currentHbox = hoverboxes[this.intCnt];
		
					/* Get the current Hover box layer for mouseover and mouseout events */
					var currentHboxLayer = currentHbox.querySelector('.hoverbox-block__action__layer');
		
					/* Get the current Hover box paragraph for content insertion/ swapping */
					var currentHboxPara = currentHbox.querySelector('.hoverbox-block__content');
		
					/* Set the events for assembled items in this iteration */
					this.HoverBoxEvents( currentHbox, currentHboxLayer, currentHboxPara, contentMessage1, contentMessage2);

					/* Will return elements here  and remove previous line in next revision */
					}

			}
		}
	/* Governs the events for this class for automatic setup */
	HoverBoxEvents(  currHbox, currHboxLayer , currHboxPg , contentMsg1, contentMsg2  ){
		/* Set the mouseover event */
		var focusTarget = currHbox.querySelector('.hoverbox-block__content');
		currHboxLayer.addEventListener( 'mouseover' , function(){
				this.parentElement.classList.add('active');
				currHboxPg.innerHTML = contentMsg2;
		});
	
			/* Set the mouseout event */
		currHboxLayer.addEventListener( 'mouseout' , function(){
			this.parentElement.classList.remove('active');
			currHboxPg.innerHTML = contentMsg1;
		});
	
		/* Set the focus event - will be same as mouseover */
		focusTarget.addEventListener( 'focus' , function(){
			this.parentElement.parentElement.classList.add('active');
			currHboxPg.innerHTML = contentMsg2;
		});
	
		/* Set the blur event - will be same as mouseout */
		focusTarget.addEventListener( 'blur' , function(){
			this.parentElement.parentElement.classList.remove('active');
			currHboxPg.innerHTML = contentMsg1;
		});

		}
	}

	export default SkyeHoverBox;
